import { render, staticRenderFns } from "./print_tax_invoice.vue?vue&type=template&id=3b5d0a10&scoped=true"
import script from "./print_tax_invoice.vue?vue&type=script&lang=js"
export * from "./print_tax_invoice.vue?vue&type=script&lang=js"
import style0 from "./print_tax_invoice.vue?vue&type=style&index=0&id=3b5d0a10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5d0a10",
  null
  
)

export default component.exports